import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  pageHeaderRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  pageHeader: {
    display: 'flex',
    flexDirection: 'column',
  },
  pageTitle: {
    fontWeight: 'bold',
    fontSize: '1.75rem',
    fontFamily: 'Roboto',
  },
  pageSubtitle: {
    color: theme.palette.text.secondary,
    fontFamily: 'Roboto',
    fontSize: '0.875rem',
  },
  newButton: {
    backgroundColor: '#4caf50',
    color: '#fff',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: '#388e3c',
    },
  },
  sectionLabel: {
    fontWeight: 'bold',
    fontSize: '1rem',
    fontFamily: 'Roboto',
    marginBottom: theme.spacing(1),
  },

  // Assessment type toggle
  typeToggleGroup: {
    marginBottom: theme.spacing(2),
  },
  typeToggleButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    padding: theme.spacing(1, 2.5),
    '&.Mui-selected': {
      backgroundColor: '#4caf50',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#388e3c',
      },
    },
  },
  typeToggleIcon: {
    marginRight: theme.spacing(1),
  },

  // Info banner
  infoBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    backgroundColor: 'rgba(76, 175, 80, 0.08)',
    border: '1px solid rgba(76, 175, 80, 0.24)',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  infoBannerIcon: {
    color: '#4caf50',
    marginTop: 2,
  },
  infoBannerText: {
    color: theme.palette.text.secondary,
  },

  // Turma / class filter section
  filterSection: {
    padding: theme.spacing(2, 3),
    marginBottom: theme.spacing(3),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  filterSectionRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    gap: theme.spacing(4),
  },
  filterLabel: {
    fontWeight: 'bold',
    fontSize: '0.875rem',
    marginBottom: theme.spacing(1),
  },
  turmaSelectBox: {
    minWidth: 260,
  },
  turmaSelect: {
    minWidth: 260,
  },
  quickFiltersBox: {
    flex: 1,
  },
  quickFiltersRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  filterChip: {
    cursor: 'pointer',
  },
  selectedClassStatus: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  statusDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#4caf50',
    flexShrink: 0,
  },
  selectedClassStatusText: {
    color: theme.palette.text.secondary,
  },

  // Stat cards
  statCardsRow: {
    marginBottom: theme.spacing(3),
  },
  statCardIconBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
    height: 48,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: 'rgba(76, 175, 80, 0.12)',
    flexShrink: 0,
  },
  statCardIcon: {
    color: '#4caf50',
    fontSize: 26,
  },

  // Table toolbar
  tableToolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
  tableTabs: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  tableToolbarActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  filtersButton: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(0.75, 1.5),
  },
  filtersButtonLabel: {
    fontWeight: 'bold',
  },
  rowActions: {
    display: 'flex',
    alignItems: 'center',
  },

  // Printed assessments table
  printedFiltersRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(3),
  },
  printedFilterSelect: {
    minWidth: 180,
  },
  resultsLink: {
    color: '#4caf50',
    fontWeight: 'bold',
    fontSize: '0.875rem',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    marginRight: theme.spacing(1),
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));